import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

/* eslint-disable max-len */
const subHeaders = {
	taskDetail: 'detail úkolu',
	note: 'poznámka',
	psInfo: 'informace o PS',
	clientData: 'údaje o klientovi',
	solverSettings: 'nastavení řešitele',
};

const formFields = {
	surname: 'Příjmení',
	name: 'Jméno',
};

const buttons = {
	createTask: 'Vytvořit úkol',
	searchButton: 'Vyhledat klienta',
};

const infoMessages = {
	taskIsBeingCreated: 'Vytváří se úkol',
};

const errors = {
	selectRadio: 'Povinný údaj Nastavení řešitele nebyl vyplněn.',
	minSearchCriteria:
		'Minimální filtrační kritéria pro vyhledávání je loginu nebo agenturní číslo nebo přijmení. Je nutné zadat alespoň jednu tuto položku',
};

const merge = {
	...subHeaders,
	...formFields,
	...buttons,
	...infoMessages,
	...errors,
};

export default Object.assign({}, merge, createLabeledMessages(merge));
